/* 
  诉求分析
  1，传入一个 number ref 值,和 配置开关
  2，开始倒计时
  3，根据真实的时间倒计时，配置开关是否真实时间
*/

class CountDown {
  constructor(options) {
    this.real = options.real == undefined;
    this.numKey = options.numKey || "CountDownNum";
    this.statusKey = options.statusKey || "CountDownStatus";
    /* 
      numKey: 'CountDownNumPhone',
      statusKey: 'CountDownStatusPhone',
    */
    this.self = options.self;
    this.status = options.status;
    this._value = options.self[this.numKey];
    this.id = options.id;
    this.callback = options.callback;
  }
  start() {
    if (this.timer) {
      return;
    }
    this.self[this.statusKey] = false;
    if (this.real) {
      this.TimeLocalStorage = new TimeLocalStorage(
        this.id,
        this.self,
        this.numKey
      );
    }
    console.log();
    let intervalFn = () => {
      if (
        this.real &&
        this.TimeLocalStorage &&
        this.TimeLocalStorage.checkExpire()
      ) {
        this.reset();
        this.callback && this.callback();
      }
      if (this.real) {
        this.self[this.numKey] = parseInt(
          (this.TimeLocalStorage.surplusTime() / 1000).toString()
        );
      } else {
        this.self[this.numKey]--;
      }
      if (this.self[this.numKey] <= 0) {
        this.reset();
        this.self[this.statusKey] = true;
        this.callback && this.callback();
      }
    };
    intervalFn();
    this.timer = window.setInterval(intervalFn, 1000);
  }
  checkStatus() {
    if (this.real && this.TimeLocalStorage) {
      return this.TimeLocalStorage.checkExpire();
    }
    return this.self[this.numKey] == this._value;
  }

  reset() {
    this.self[this.numKey] = this._value;
    clearInterval(this.timer);
    this.timer = undefined;
  }
}

class TimeLocalStorage {
  constructor(id, self, numKey) {
    this.timeStamp = new Date().getTime() + self[numKey] * 1000; // 时间戳
    if (!this.checkLocalExist(id) || this.checkExpire(id)) {
      localStorage.setItem(id, `${this.timeStamp}`);
    }

    this.id = id;
  }
  getCurrentTitme() {
    return new Date().getTime();
  }

  // exist
  checkLocalExist(id) {
    if (localStorage.getItem(id || this.id) == "NaN") {
      return false;
    }
    return localStorage.getItem(id || this.id) ? true : false;
  }
  // 检查时间走完倒计时
  // 走完了 返回 true
  checkExpire(id) {
    let timeStamp = Number(localStorage.getItem(id || this.id));
    // if (!timeStamp) {
    //   return false
    // }
    return this.getCurrentTitme() > timeStamp;
  }
  // 剩余时间
  surplusTime(id) {
    let timeStamp = Number(localStorage.getItem(id || this.id));

    if (!this.checkExpire(id || this.id)) {
      return timeStamp - this.getCurrentTitme();
    }
    return 0;
  }
}

export default CountDown;
